module.exports = __webpack_public_path__ + "img/2019.17697a5f.jpg";